/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSelfImprovementIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-self-improvement"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.7 20.5Q5.8 20.5 5.17 19.88Q4.55 19.25 4.55 18.35Q4.55 17.7 4.9 17.11Q5.25 16.52 5.85 16.3L9.65 14.8L9.65 13.38Q8.7 14.47 7.11 15.21Q5.53 15.95 3.75 16.18Q3.2 16.25 2.8 15.88Q2.4 15.5 2.4 14.93Q2.4 14.38 2.79 13.97Q3.17 13.57 3.75 13.5Q5.13 13.3 6.25 12.68Q7.38 12.05 8.3 10.95L9.65 9.3Q10 8.88 10.49 8.66Q10.97 8.45 11.5 8.45L12.5 8.45Q13.03 8.45 13.51 8.66Q14 8.88 14.35 9.3L15.7 10.95Q16.63 12.05 17.75 12.68Q18.88 13.3 20.25 13.5Q20.82 13.57 21.21 13.97Q21.6 14.38 21.6 14.93Q21.6 15.5 21.2 15.88Q20.8 16.25 20.25 16.18Q18.48 15.95 16.89 15.21Q15.3 14.47 14.35 13.38L14.35 14.8L18.15 16.3Q18.75 16.52 19.1 17.11Q19.45 17.7 19.45 18.35Q19.45 19.25 18.82 19.88Q18.2 20.5 17.3 20.5L9.95 20.5L9.95 19.8Q9.95 19.13 10.46 18.61Q10.97 18.1 11.65 18.1L14.55 18.1Q14.78 18.1 14.91 17.96Q15.05 17.82 15.05 17.6Q15.05 17.38 14.91 17.24Q14.78 17.1 14.55 17.1L11.65 17.1Q10.53 17.1 9.74 17.89Q8.95 18.68 8.95 19.8L8.95 20.5ZM12 7.7Q12 7.7 11.53 7.7Q11.05 7.7 10.4 7.05Q9.75 6.4 9.75 5.45Q9.75 4.5 10.4 3.85Q11.05 3.2 12 3.2Q12.95 3.2 13.6 3.85Q14.25 4.5 14.25 5.45Q14.25 6.4 13.6 7.05Q12.95 7.7 12 7.7Z" fill={color} />
    </svg>
  );
}
